export enum LoadingStatus {
  Loaded,
  InProcess
}
